import {useContext, useState} from "react";
import { UserContext } from '../Context/UserContext';
import OldPicks from "./OldPicks";
import PickResults from "./PickResults";
import "../styles/picks.css"
import FormattedDate from "./FormattedDate"

function Picks() {
    const {state} = useContext(UserContext);
    const [showOldPicks, setShowOldPicks] = useState(false)
    const currentDate = new Date().toLocaleDateString("en-CA", {
        timeZone: "America/Chicago", // Central Time
    });

    function handleShowOldPicks() {
        setShowOldPicks(!showOldPicks)
    }

    const articles = state.articles?.map(art => {
        const relAuthor = state?.authorsAndResults?.find(obj => obj?.author.id === art?.author_id)
        //console.log('relAuthor', relAuthor)
        const authorName = relAuthor?.author.first_name + ' ' + relAuthor?.author.last_name
        const artDate = new Date(art.created_at).toISOString().split("T")[0]
        const formattedArtDate = artDate.slice(5)
        //console.log('formattedArtDate', formattedArtDate)
        if (artDate === currentDate)
        return (
            <div className="articles" key={art.id}>
                <h2 className="title">{art.title}</h2>
                <p className="bet">{authorName}'s Bet:</p>
                <p className="bet">{art.bet}</p>
                {art.body.split(/\n\s*\n/).map((para, i) => (
                    <p className="story" key={i}>{para.trim()}</p>
                ))}
                {art.conclusion.split(/\n\s*\n/).map((para, i) => (
                    <p className="story" key={i}>{para.trim()}</p>
                ))}
                {/* <p className="authorName">By: {authorName}</p> */}
            </div>
        )
        // else return ''
    })
    
    return (
        <div className="picks">
            <h1>Picks for {<FormattedDate />} </h1>
            {/* <h2 className="comingSoonHeader">Picks Coming Soon</h2> */}
            <PickResults articles={state.articles}/>
            {articles}
            <button id="picksBtn" onClick={handleShowOldPicks}>{showOldPicks ? "Hide Old Picks" : "See Old Picks"}</button>
            <br />
            {showOldPicks && <OldPicks currentDate={currentDate}/>}
        </div>
    )
}

export default Picks